// extracted by mini-css-extract-plugin
module.exports = {"income-by-gender":"incomeByGender_income-by-gender__obR_B"};